var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2998 -0.00146484C15.6135 -0.00146484 18.2998 2.68483 18.2998 5.99854C18.2998 7.0108 18.2263 8.09569 18.0792 9.25323C17.6456 11.4019 16.8664 13.0045 15.3004 14.5705C13.8322 16.0387 12.2169 16.9482 9.98554 17.6722C8.75907 18.039 6.2998 17.9985 6.2998 17.9985C2.9861 17.9985 0.299805 15.3122 0.299805 11.9985V5.99854C0.299805 2.68483 2.9861 -0.00146484 6.2998 -0.00146484H12.2998ZM12.2998 1.19854H6.2998C3.64884 1.19854 1.4998 3.34757 1.4998 5.99854V11.9985C1.4998 14.6495 3.64884 16.7985 6.2998 16.7985L8.1601 16.8003C8.9199 16.7579 9.2998 16.4026 9.2998 15.7347L9.29981 14.091C9.29981 11.3406 11.5212 9.10664 14.2715 9.09109L14.9302 9.08225L15.3423 9.06936C15.7193 9.0538 15.9911 9.03019 16.1576 8.99854C16.7498 8.88595 17.0644 8.4313 17.1014 7.6346L17.0998 5.99854C17.0998 3.34757 14.9508 1.19854 12.2998 1.19854ZM16.3817 10.1774C16.5136 10.1524 16.6386 10.1189 16.7656 10.0747C16.2896 11.4414 15.5206 12.6532 14.4518 13.722C13.357 14.8168 12.0209 15.6873 10.4351 16.3339C10.4776 16.1483 10.4998 15.9484 10.4998 15.7347L10.4998 14.091C10.4998 12.0007 12.1881 10.3029 14.2783 10.2911L14.7666 10.2858C15.5314 10.273 16.0542 10.2397 16.3817 10.1774Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/Gallery.a10764cce6430224d8d2ded68b9950f4.svg";
export { ForwardRef as ReactComponent };